import React from 'react';

import './Anchor.css';

interface AnchorProps {
  id: string;
}

const Anchor: React.FC<AnchorProps> = ({ id }) => {
  return <div id={id} className="anchor"></div>;
};

export default Anchor;
